import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'

const routes = [
  { path: '/', component: () => import('./routes/Home.vue') },
  { path: '/catalog', component: () => import('./routes/Catalog.vue') },
  { path: '/catalog/:id', component: () => import('./routes/Piece.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Catalog restores its own saved position; scrolling here would clobber it
    if (to.path === '/catalog') return false
    return savedPosition || { top: 0 }
  },
})

router.afterEach((to) => {
  const canonical = document.querySelector('link[rel="canonical"]')
  if (canonical) canonical.href = 'https://lumatron.art' + to.path
})

const app = createApp(App)
app.use(router)
app.mount('#app')
